module.exports = __webpack_public_path__ + "static/media/Daikin-logo.24f6cbd2.png";